// extracted by mini-css-extract-plugin
module.exports = {"squareOne":"importData_squareOne__2dB_e","menuGridContainer":"importData_menuGridContainer__1JGaW","textContainer":"importData_textContainer__23WCX"};